module.exports = __webpack_public_path__ + "img/collect-overlay.362def30.png";